import { render, staticRenderFns } from "./jumpbaike.vue?vue&type=template&id=705d45fb&scoped=true"
import script from "./jumpbaike.vue?vue&type=script&lang=js"
export * from "./jumpbaike.vue?vue&type=script&lang=js"
import style0 from "./jumpbaike.vue?vue&type=style&index=0&id=705d45fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d45fb",
  null
  
)

export default component.exports